import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {SendInvitationRequestInterface} from 'src/app/interfaces/send-invitation-request.interface';
import {EventsManager} from 'src/app/services/events.manager';

@Injectable({
  providedIn: 'root'
})

export class SalesService {
  private _httpClient = inject(HttpClient);
  public eventsManager = inject(EventsManager);

  public options: HttpHeaders = new HttpHeaders({});

  public sendInvitation(phoneNumber: string, captchaResponse: string): Observable<any> {
    const url = `${environment.salesApiUrl}services/send-mysmile-invite`;
    const request: SendInvitationRequestInterface = {
      phoneNumber: phoneNumber,
      captchaResponse: captchaResponse,
      site: 'sgdp'
    };
    return this._httpClient.post<void>(url, request);
  }
}
